import React, { useState } from "react";
import { useForm } from "react-hook-form";
import BtnLoader from "./BtnLoader";
import axios from "axios";
import { RESETPASSWORD_API } from "../app/constants";
import { BASE_URL } from "..";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ResetPasswordSection = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    watch,
  } = useForm({
    mode: "onChange", // Validate the form on each change
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const newPassword = watch("newPassword"); // Watch the newPassword field

  const handleResetPassword = async (data) => {
    const { newPassword, confirmPassword } = data;

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setIsLoading(true);
    const userId = sessionStorage.getItem("userId");
    const resetToken = sessionStorage.getItem("resetToken");

    try {
      const response = await axios.post(`${BASE_URL}${RESETPASSWORD_API}`, {
        userId,
        resetToken,
        newPassword,
      });

      if (response.status === 200 && response.data.code === 1) {
        toast.success("Password reset successfully.");
      } else {
        toast.error(response.data.message || "An unexpected error occurred.");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Failed to reset password. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prevState) => !prevState);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  return (
    <section className="flex-center bg-light">
      <ToastContainer />
      <div className="container container-lg flex-center bg-white py-40">
        <div className="gy-4 rounded bg-white d-flex flex-column flex-lg-row gap-10">
          <div
            className="col-xl-6 p-0 order-lg-1 order-2 flex-center flex-column mt-0"
            style={{
              maxWidth: "26rem",
              minHeight: "33rem",
              background:
                "linear-gradient(to bottom, #FE5014, #FE5014, #FD9B7B, #FFC6C6)",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <h4 className="text-capitalize text-white p-20 pt-40">
              Shopping with lowest prices & maximum discounts
            </h4>
            <p className="text-white px-20">
              We are connected with wholesalers to offer the best price on every
              item you buy
            </p>
            <img
              className="mt-40"
              src="assets/images/icon/login-img.png"
              alt="LoginImg"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div
            className="card d-flex justify-content-center p-24 order-lg-2 order-1 border-0"
            style={{ maxWidth: "23rem", width: "100%" }}
          >
            <div className="flex-center flex-column mb-24">
              <img
                style={{ width: "10rem" }}
                src="assets/images/logo/header_logo.png"
                alt="Logo"
              />
              <p className="text-2xl fw-bolder text-black">Reset Password</p>
              <p className="text-xs text-center text-muted">
                Enter your new password below to reset your account password.
              </p>
            </div>

            <form onSubmit={handleSubmit(handleResetPassword)}>
              {/* New Password Input */}
              <div className="my-20 position-relative">
                <input
                  type={showNewPassword ? "text" : "password"}
                  className="form-control common-input"
                  placeholder="New Password"
                  {...register("newPassword", {
                    required: "New password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Password must include uppercase, lowercase, digit, and special character",
                    },
                  })}
                />
                <p
                  className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer"
                  onClick={toggleNewPasswordVisibility}
                >
                  <i
                    className={`bi ${
                      showNewPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </p>
                {errors.newPassword && (
                  <div className="position-absolute text-xs text-danger mt-2">
                    {errors.newPassword.message}
                  </div>
                )}
              </div>

              {/* Confirm Password Input */}
              <div className="my-40 position-relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control common-input"
                  placeholder="Confirm Password"
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === newPassword || "Passwords do not match",
                  })}
                />
                <p
                  className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  <i
                    className={`bi ${
                      showConfirmPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </p>
                {errors.confirmPassword && (
                  <div className="position-absolute text-xs text-danger mt-2">
                    {errors.confirmPassword.message}
                  </div>
                )}
              </div>

              {/* Submit Button */}
              <div className="mt-24 w-100">
                <button
                  type="submit"
                  className="w-100 btn py-18 px-40 rounded-0 shadow"
                  style={{ background: "#FE5014" }}
                  disabled={!isValid || isLoading}
                >
                  {isLoading ? <BtnLoader /> : "Reset Password"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPasswordSection;
